import { Directive, Injector, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { FrameContext } from '@farris/devkit';
import { ListFilterComponent } from '@farris/ui-list-filter';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[farris-list-filter-binding]'
})
export class FarrisListFilterBindingDirective implements OnInit, OnDestroy {
  private $destroy: Subject<any>;
  /**
   * åéç¼å·ï¼é»è®¤ä¸ºfilterConditionList
   */
  @Input('variableCode') variableCode = 'filterConditionList';
  constructor(
    private injector: Injector,
    private frameContext: FrameContext,
    @Optional() private listFilterComponent: ListFilterComponent
  ) {
    this.$destroy = new Subject<any>();
  }
  ngOnDestroy(): void {
    if (this.$destroy) {
      this.$destroy.next();
      this.$destroy.complete();
    }
  }
  ngOnInit(): void {
    if (this.listFilterComponent) {
      this.listFilterComponent.conditionsChange.pipe(takeUntil(this.$destroy)).subscribe((event: any) => {
        const { data = '[]' } = event || {};
        this.setConditions(data);
      });
    }
  }
  private setConditions(conditions: string) {
    this.frameContext.uiState.setPropertyValue(this.variableCode, conditions);
  }
}
